import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'cft-holy-grail-grid-content',
  templateUrl: './holy-grail-grid-content.component.html',
  styles: [
    `
      :host {
        @apply block w-full overflow-x-clip px-md;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolyGrailGridContentComponent {}
